import HeaderPortal from "components/portal/header-portal";
import { FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Form } from "react-crud-form";
import React from "react";
import { Textarea } from "ui/components/textarea";
import { useHotkeys } from "react-hotkeys-hook";
import { Button } from "ui/index";
import { useParams } from "react-router-dom";
import { resultsSchema } from "./schema";
import { useResultsForm } from "./useResultsForm";

const ResultForm = () => {

    const { casestudyId } = useParams();

    const {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    } = useResultsForm({ casestudyId });

    return (
        <div className="flex-1 max-w-md p-4">
            <Form
                form={form}
                create={handleCreate}
                read={handleRead}
                update={handleUpdate}
                itemId={casestudyId || "+"}
                schema={resultsSchema}
            >
                {({
                    isCreating,
                    createItem,
                    isNewItem,
                    isUpdating,
                    updateItem,
                    isDirty,
                }) => {
                    useHotkeys(
                        "ctrl+s, cmd+s",
                        (event) => {
                            event.preventDefault();
                            if (!isCreating) {
                                setIsNew(false);
                                createItem().then(handleClose);
                            }
                        },
                        { preventDefault: true }
                    );
                    useHotkeys(
                        "ctrl+shift+s, cmd+shift+s",
                        (event) => {
                            event.preventDefault();
                            if (!isCreating) {
                                setIsNew(true);
                                createItem();
                            }
                        },
                        { preventDefault: true }
                    );
                    return (
                        <div className="space-y-6">

                            {/* Solution Overview */}
                            <FormField
                                control={form.control}
                                name="solution_overview"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Solution Overview</FormLabel>
                                            <Textarea {...field} className="min-h-32" />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Obstacles */}
                            <FormField
                                control={form.control}
                                name="obstacles"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Obstacles</FormLabel>
                                            <Textarea {...field} className="min-h-32" />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Methodology */}
                            <FormField
                                control={form.control}
                                name="methodology"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Methodology</FormLabel>
                                            <Textarea {...field} className="min-h-32" />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Achievements */}
                            <FormField
                                control={form.control}
                                name="achievements"
                                render={({ field }) => {
                                    return (
                                        <FormItem>
                                            <FormLabel required={requiredFields.includes(field.name)}>Achievements</FormLabel>
                                            <Textarea {...field} className="min-h-32" />
                                            <FormMessage />
                                        </FormItem>
                                    );
                                }}
                            />

                            {/* Portal buttons similar to TimesheetLog */}
                            <HeaderPortal>
                                {isNewItem ? (
                                    <Button
                                        variant="default"
                                        isLoading={isCreating}
                                        onClick={createItem}
                                    >
                                        Save
                                    </Button>
                                ) : (
                                    <Button
                                        variant="default"
                                        isLoading={isUpdating}
                                        disabled={!isDirty}
                                        onClick={updateItem}
                                    >
                                        Save
                                    </Button>
                                )}
                            </HeaderPortal>
                        </div>
                    );
                }}
            </Form>
        </div>
    );
};

export default ResultForm;
